import { render } from "./ClientContabilidadAsientos.vue?vue&type=template&id=f8455fbe"
import script from "./ClientContabilidadAsientos.vue?vue&type=script&lang=js"
export * from "./ClientContabilidadAsientos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__